export default __webpack_public_path__ + "static/media/BaremEvalLogo.d522e5c6.svg";